import { render } from "./StoreList.vue?vue&type=template&id=604f1c8f&ts=true"
import script from "./StoreList.vue?vue&type=script&lang=ts"
export * from "./StoreList.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__